module.exports = __webpack_public_path__ + "static/media/lightbulb-slash.e68f1edd.svg";